export const entrance = "고객님께서 티켓 발권 센터에 입장하셨습니다.";
export const natasha = [
    // natasha speaking 1
    ": 안녕하세요 고객님,<br />대왕트래블에 오신 것을 환영합니다.",
    ": 저는 고객님의 담당 가이드, 나타샤 입니다.",
    //natasha speaking 2
    ": 나타샤는 칭첸 사람입니다.<br />한국 사람 아니에요.<br />한국말은 사장님이 가르쳐줬습니다.",
    ": 티켓 발권에 앞서, <br />두 가지 주의사항 안내드립니다.",
    ': <span class="jh-yellow">[1]</span> 저희 투어는 <span class="text-red-blink">성인들만 이용 가능</span>하시며, <br />미성년자 출입시 책임을 지지 않습니다.',
    ': <span class="jh-yellow">[2]</span> 투어 <span class="text-red-blink"/>총 소요시간은 15분</span>이며, <br />관람 중단시 재입장은 불가합니다.',
    ": 위 내용을 모두 확인하셨습니까?",
    // natasha speaking 3
    ": 감사합니다. <br />현재 고객님의 티켓이 발권되고 있습니다. ",
    ": 위의 티켓을 클릭하여 입장해주십시오.<br />칭쳰에서 뵙겠습니다!",
];
export const response = "네, 확인하였습니다.";
//# sourceMappingURL=texts.js.map